export default "__VITE_ASSET__CQF3iKx6__"